import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav';
import Header from '../../../component/layout/header';

const SettingOrganizationLayout = () => {
  const navList = useNav();
  let {SettingTopNav, SettingOrgBottomNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={SettingOrgBottomNav} topTabs={SettingTopNav} />
      <Outlet />
    </div>
  )
}

export default SettingOrganizationLayout